var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "lds-spinner" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner flex-column items-center justify-center" },
      [
        _c("i", {
          staticClass: "el-icon-loading",
          staticStyle: {
            color: "#FFFFFF",
            "font-size": "18px",
            "font-weight": "bold",
          },
        }),
        _c("div", { staticClass: "loading-text" }, [_vm._v("Loading...")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }